<template>
    <div>
        <loading :active="loading" :is-full-page="false" />
        <div class="wbs-table-button-area">
            <!-- <button @click="expandAll" class="expand-all-button">Expand All</button> -->
            <!-- <button @click="collapseAll" class="collapse-all-button">Collapse All</button> -->
            <base-button :disabled="expandableItemCount === expandedItemCount" style="margin-right: 0.3em;" @click="expandAll" size="xs" variant="primary">Expand All</base-button>
            <base-button :disabled="expandedItemCount === 0" @click="collapseAll" size="xs">Collapse All</base-button>
            <!-- <button @click="expandAll" class="expand-all-button">Expand All</button>
            <button @click="collapseAll" class="collapse-all-button">Collapse All</button> -->
            
            <!-- <b-progress :value="50" :max="100">
                <template #label>
                    <div class="text-center">Progress: <strong>{{ closed }}  / {{ total }}</strong></div>
                </template>
            </b-progress> -->
            <div style="width: 80%; height:1.5rem; margin:0 auto; display: flex; align-items: center;">
                <progress-bar
                    :toDo="toDo"
                    :inProgress="inProgress"
                    :done="done"
                    :cancelled="cancelled"
                    :closed="closed"/>
            </div>
            
            
            <!-- <b-progress class="wbs-progress-bar" :value="progress" /> -->
            <!-- <div class="progress-wrapper">
                <span class="wbs-progress-label">
                    Progress : {{ closed }} / {{ total }}
                </span>
                <div class="progress-bar" :style="{ width: progress + '%' }"></div>
            </div> -->
        </div>
        <!-- <div style="display: flex; width: 100%; position: relative;" :class="{'scrollable' : showScheduleChart}"> -->

        <div class="custom-table-container" style="display: flex; width: 100%; overflow-x: hidden;" ref="wbsArea">
            <!-- <table class="wbs-table" style="width: 100%; flex-shrink: 0; position: sticky; left: 0;"> -->
            <table class="wbs-table custom-table" :style="{display: isWbsChartExpanded ? 'none' : ''}" :class="{'show-schedule-chart' : showScheduleChart} ">
                <div>
                    <div class="wbs-thead">
                        <span>Title</span>
                        <span>Progress</span>
                        <span>Status</span>
                        <!-- <th>Assignee</th> -->
                    </div>
                </div>
                <tbody class="wbs-body" style="background-color: white;">
                    <tr v-if="!devMethodologyList || devMethodologyList.length == 0">
                        <td colspan="11" style="text-align:center">결과가 없습니다.</td>
                    </tr>
                    <template v-else-if="devMethodologyList[0].id">
                        <template v-for="devMethodology in devMethodologyList" >
                            <dev-methodology-row  :devMethodology="devMethodology" :depth="0" :key="devMethodology.id"/>
                        </template>
                    </template>
                    <template v-else-if="devMethodologyList[0].chatId">
                        <template v-for="chatter in devMethodologyList" >
                            <chatter-row :chatter="chatter" :depth="0" :key="chatter.chatId"/>
                        </template>
                    </template>
                    
                    <!-- <template v-for="chatter in devMethodologyList" >
                        <chatter-row :chatter="chatter" :depth="0" :key="chatter.chatId"/>
                    </template> -->
                </tbody>
            </table>
            <div v-if="showScheduleChart" class="wbs-schedule-chart-wrapper" ref="wbsScheduleChartWrapper" >
                <div class="wbs-schedule-chart" :style="{width: chartWidth}"  >
                    <div class="wbs-thead">
                        <!-- <button class="schedule-chart-expand-button" @click="clickExpandButtonHandler">
                            <b-icon :icon="isWbsChartExpanded ? 'arrow-bar-right' : 'arrow-bar-left'" style="width: 1.3rem;" font-scale="1"/>
                        </button> -->
                        <span v-for="(month, index) in months" class="schedule-date-col" :key="index">
                            {{ month }}
                        </span>
                    </div>
                    <div class="wbs-body" style="background-color: white;">
                        <template v-if="devMethodologyList[0].id">
                            <template v-for="devMethodology in devMethodologyList">
                                <dev-methodology-schedule-bar :devMethodology="devMethodology" :key="devMethodology.id" />                    
                            </template>
                        </template>
                        
                        <template v-if="devMethodologyList[0].chatId">
                            <template v-for="devMethodology in devMethodologyList">
                                <chatter-schedule-bar :chatter="devMethodology" :key="devMethodology.chatId" />                    
                            </template>
                        </template>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import DevMethodologyRow from './DevMethodologyRow.vue';
    import ChatterRow from "@/components/chatter/wbs/ChatterRow.vue";
    import DevMethodologyScheduleBar from './DevMethodologyScheduleBar.vue';
    import ChatterScheduleBar from './ChatterScheduleBar.vue';
    import ProgressBar from './ProgressBar.vue';
    import BaseButton from '../requirement/BaseButton.vue';

    export default {
        name: "WbsTable",
        props: {
            devMethodologyList:{type:Array},
            startDate: {type: String},
            endDate: {type: String},
            total: {type: Number, default: 0},
            toDo: {type: Number, default: 0},
            inProgress: {type: Number, default: 0},
            done: {type: Number, default: 0},
            cancelled: {type: Number, default: 0},
            closed: {type: Number, default: 0},
            progress: {type: Number, default: 0},
        },
        watch: {
           
            '$refs.wbsScheduleChartWrapper':{
                deep: true,
                immediate: true,
                handler() {
                    this.chartWidth = this.$refs.wbsScheduleChartWrapper.clientWidth;
                }
            }
        },
        created() {
            this.months = this.getMonthBetweenProjectDuration();
            this.loading = true;
        },
        mounted() {
            this.loading = false;
            this.chartWidth = this.calculateChartWidth();
        },
        components : {
            DevMethodologyRow,
            ChatterRow,
            DevMethodologyScheduleBar,
            ChatterScheduleBar,
            Loading,
            ProgressBar,
            BaseButton
        },
        computed: {
            showScheduleChart() {
                return this.startDate !== '' && this.endDate !== '';
            },
            getMonths() {
                return this.getMonthBetweenProjectDuration();
            },
            scrollable() {
                return this.showScheduleChart ? {overflowX: 'scroll;'} : '';
            },
            borderRadiusByShowScheduleChart() {
                return this.showScheduleChart ? {'border-top-right-radius' : '0px;', 'border-bottom-right-radius' : '0px'} : '';
            },
            isWbsChartExpanded() {
                return this.$store.getters['wbs/getWbsScheduleChartExpandState'];
            },
            wrapperWidth() {
                return this.$refs.wbsScheduleChartWrapper.clientWidth;
            },
            expandableItemCount() {
                return this.$store.getters['wbs/getExpandableItemCount'];
            },
            expandedItemCount() {
                return this.$store.getters['wbs/getExpandedItemCount'];
            }
        },
        data() {
            return {
                months: [],
                loading: false,
                chartWidth: 0,
            }
        },
        methods: {
            expandAll() {
                this.devMethodologyList.forEach(devMethodology => {
                    this.expandAllDevMethodology(devMethodology);
                });
            },
            calculateChartWidth() {
                // return {width : (this.months.length * 200) + 'px'}
                
                let currentWrapperWidth = this.wrapperWidth;
                // let currentWrapperWidth = this.$refs.wbsScheduleChartWrapper.clientWidth;
                // wrapper의 클라이언트 넓이 구하기
                
                
                // expand = false 시
                // 기준 months = 6
                // expand = true 시
                // 기준 months = 12
                let minColSize = 7;

                // months 기준보다 작으면 
                // chart의 넓이를 wrapper의 넓이로 변경
                if(this.months.length < minColSize) {
                    return '100%';
                }

                // months 기준보다 크면

                // 컬럼 최소 넓이 구하기
                // wrapper / months의 길이 
                const colWidth = currentWrapperWidth / minColSize;
                const maxChartWidth = colWidth * this.months.length;
  
                // months * 컬럼 최소 넓이 < wrapper의 넓이
                if(maxChartWidth <= currentWrapperWidth) {
                    // chart의 넓이를 wrapper의 넓이로 변경 wrapper의 넓이
                    return '100%';
                }
                
                // months * 컬럼 최소 넓이 > wrapper의 넓이
                // chart의 넓이를 months * 컬럼 최소 넓이로 변경
                return maxChartWidth + 'px';
            },
            expandAllDevMethodology(devMethodology) {

                const id = devMethodology.id;
                this.$store.commit("wbs/setExpanded", {id: id, isExpanded: true});

                // TODO ScheduleChart 구현 후 주석 해제
                devMethodology.chatterList.forEach(rootChatter => {
                    // 파라미터로 넘겨준 Chatter의 모든 SubChatter들을 가져옴 (필터링 적용)
                    this.expandAllSubChatterList(rootChatter)
                });

                // if(devMethodology.children.length == 0) {
                //     return searchResult;
                // }
                
                devMethodology.children.forEach(nextDevMethodology => {
                    this.expandAllDevMethodology(nextDevMethodology);
                });

                return;
            },

            expandAllSubChatterList(chatter) {

                this.$store.commit("wbs/setExpanded", {id:chatter.chatId, isExpanded:true});

                // if(!chatter.subChatterList || chatter.subChatterList.length == 0) {
                //     return;
                // }

                chatter.subChatterList.forEach(subChatter => {
                    this.expandAllSubChatterList(subChatter);
                });

                return;
            },
            collapseAll() {
                this.$store.commit('wbs/resetExpanded');
            },
            getMonthBetweenProjectDuration() {
                if(!this.showScheduleChart) {
                    return [];
                }
                
                const startDateObj = new Date(this.startDate);
                const endDateObj = new Date(this.endDate);
                const months = [];

                let currentDate = new Date(startDateObj);
                while(currentDate <= endDateObj) {
                    months.push(currentDate.toISOString().slice(0, 7));

                    currentDate.setMonth(currentDate.getMonth() + 1);

                    currentDate.setDate(1);
                }
                
                return months;
            },
            clickExpandButtonHandler() {
                this.$store.commit('wbs/setWbsScheduleChartExpandState', !this.isWbsChartExpanded);
                this.chartWidth = this.calculateChartWidth();
            }
        }
    }
</script>
<style scoped>
    .wbs-table{
        width: 100%;
        border-collapse: collapse;
    }
    table tr {
        border: none;
    }
   
    .wbs-table thead {
        color: rgb(46, 46, 56);
    }
    .wbs-body {
        border-top: 1px solid #C4C4CD;
    }
    .wbs-table.show-schedule-chart {
        width: 35%;
        flex-shrink: 0; 
        /* position: sticky;  */
        left: 0;   
        border-right: 1px solid #F6F6FA;
    }
    .scrollable {
        overflow-x: scroll;
    }
    .wbs-thead {
        display: flex;
        position: relative;
        background-color: #F6F6FA;
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
        /* border-radius: 10px; */
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;       
        margin-bottom: 0.8rem;
    }
    .wbs-table.show-schedule-chart .wbs-thead {
        border-top-right-radius: 0px;
        border-bottom-right-radius: 0px;
    }
    .wbs-thead span {
        flex: 1;
        text-align: center;
        font-weight: bold;
    }
    .wbs-thead span:first-child {
        flex: 3;
    }

    .wbs-table-button-area {
        margin-bottom: 0.3rem;
        display: flex;
        align-items: center;
    }
    .wbs-table-button-area button{
        width: 90px;
        border-radius: 10px;
        border: none;
        font-weight: bold;
        font-size: 13px;
        padding: 0 0.5rem;
        
    }
    .wbs-table-button-area button.expand-all-button {
        margin-right: 5px;
        background-color: rgb(46, 46, 56);
        color: #FFE305;
    }

    
    .wbs-table-button-area button.collapse-all-button {
        background-color: #d9d9db;
    }

    .wbs-schedule-chart-wrapper {
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        position: relative;
    }
    .wbs-schedule-chart-wrapper::-webkit-scrollbar {
        /* position: absolute;
        bottom: 30; */
        /* display: none; */
    }
    .wbs-schedule-chart .wbs-thead{
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .wbs-schedule-chart .wbs-thead .schedule-date-col {
        flex: 1;
    }

    .schedule-chart-expand-button {
        position: sticky;
        border: none;
        height: 70%;
        /* width: 3rem; */
        left: 0;
        top: 3%;
        padding: 0 0.5rem;
        background-color: #F6F6FA;
    }

    .wbs-progress-label {
        font-weight: bold;
        margin: 0 1rem 0 3rem;
    }
    .wbs-progress-bar {
        width: 60%;
        height: 1.3rem;
    }

    .custom-table-container {
        margin-top: 1rem;
        padding: 0.666rem;
        border-radius: 20px;
        background-color: #F6F6FA;
    }

    .progress-wrapper {
        margin: 0 auto;
        width: 80%;
        height: 1.5rem;
        position: relative;
        margin-top: 4px;
        border-radius: 14px;
        background: #D8E7FF;
        overflow: hidden;
    }
    .progress-wrapper .progress-bar {
        position: absolute;
        left: 0;
        border-radius: 14px 0 0 14px;
        height: 100%;
        font-size: 12px;
        text-align: left;
        overflow: visible;
        background-color: #142459;
    }
    .progress-wrapper .wbs-progress-label {
        position: absolute;
        left: 0;
        color: white;
        z-index: 1;
    }
</style>